import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT;

class UserService {
    login(user) {
        return axios.post(`${API_URL}/auth/login`, user);
    }
    update(user) {
        return axios.put(`${API_URL}/users/update`, user, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    changePassword(data) {
        return axios.put(`${API_URL}/users/change-password`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    upload(formData) {
        return axios.post(`${API_URL}/users/upload-avatar`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'multipart/form-data'
            }
        });
    }
}

export default new UserService();